import { TrackingContext } from '@change-corgi/core/react/tracking';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import { StripeLoader } from 'src/app/shared/components/payments';
import { PaypalProvider } from 'src/app/shared/hooks/payments';

import { Footer } from './components/Footer';
import { GeneralErrorMessage } from './components/GeneralErrorMessage';
import { Header } from './components/Header';
import { MembershipForm } from './container/MembershipForm';
import { MembershipModalStateContextProvider, useMembershipModalState } from './modalContext/modalState';
import type { ModalOptions, TrackingProperties } from './shared/types';
import { getAverageAmount } from './shared/utils/averageAmountExperiment';

type Options = ModalOptions & {
	properties: TrackingProperties;
};

export const useMembershipAskModal = createModalHook<Options, { accepted: boolean; amount: number }>({
	name: 'MembershipModal',
	closeButton: false,
	closeOnEscape: false,
	closeOnClickOutside: false,
	variant: 'fullPage',
	body: function MembershipModalBody({ closeModal }) {
		const [{ amount }] = useMembershipModalState();

		return (
			<div className="mx-auto w-full max-w-[1216px] pt-0 md:w-[740px] md:pt-[5%] lg:w-[960px] xl:w-[1216px]">
				<div className="mx-auto w-full px-0 md:w-4/5 md:px-8 lg:w-1/2">
					<Header />
					<MembershipForm
						onAccept={() => closeModal({ accepted: true, amount })}
						onDecline={() => closeModal({ accepted: false, amount })}
					/>
					<GeneralErrorMessage />
					<Footer />
				</div>
			</div>
		);
	},
	decorator: ({ children, options: { properties, ...modalState } }) => {
		const initialAmount = getAverageAmount(modalState.ppmuAverageAmountExperiment) || modalState.amount;
		return (
			<MembershipModalStateContextProvider {...modalState} amount={initialAmount}>
				<TrackingContext properties={properties}>
					<StripeLoader>
						<PaypalProvider>{children}</PaypalProvider>
					</StripeLoader>
				</TrackingContext>
			</MembershipModalStateContextProvider>
		);
	},
});
